import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AuTableLayoutComponent } from './au-table-layout.component';
import { AuTableComponent } from './au-table/au-table.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatRippleModule } from '@angular/material/core';
import { NestPipe } from './pipes/nest.pipe';
import { AuTableCmmsColumnComponent } from './au-table-cmms-column/au-table-cmms-column.component';
import { InitialPipe } from './pipes/initial.pipe';
import { AuPipesModule } from '../../pipes/au-pipes.module';
import { NestedPropPipe } from '@shared/pipes/map.pipe';

// Do not change direct path as it will resolve into circular dependency
import { AuExpandableTagsModule } from '../au-expandable-tags/au-expandable-tags.module';
import { AuBodyHeadingModule } from '../au-body-heading-component/au-body-heading.module';
import { AuBodyTextModule } from '../au-body-text/au-body-text.module';
import { AuAvatarWithNameModule } from '@shared/ui-components/au-avatar-with-name/au-avatar-with-name.module';
import { AuBodyTextGreyModule } from '../au-body-text-grey/au-body-text-grey.module';
import { AuStatusLabelModule } from '../au-status-label/au-status-label.module';
import { AuCmmsStatusLabelModule } from '../au-cmms-status-label/au-cmms-status-label.module';
import { AuLinkedObjectBtnModule } from '@shared/ui-components/au-linked-object-btn/au-linked-object-btn.module';
import { AuFileNameModule } from '@shared/ui-components/au-file-name/au-file-name.module';
import { ClassificationTypesMenuComponent } from './au-table-header-components/classification-types-menu/classification-types-menu.component';
import { AuDocumentTypeComponent } from '@shared/ui-components/au-document-type/au-document-type.component';
import { NgxMaskPipe } from 'ngx-mask';
import { AuNsColumnComponent } from '@shared/ui-components/au-ns-column/au-ns-column.component';
import { AuCmmsLabelColumnComponent } from '@shared/ui-components/au-cmms-label-column/au-cmms-label-column.component';
import { AuPriorityLevelComponent } from '@shared/ui-components/au-priority-level/au-priority-level.component';
import { AssetConditionGradeComponent } from '@app/pages/cmms/components/assets/asset-condition-grade/asset-condition-grade.component';
import { AuClassificationSuggestionBadgeComponent } from '../au-classification-suggestion-badge/au-classification-suggestion-badge.component';
import { AuKeyValueComponent } from '../au-key-value-text/au-key-value.component';
import { NgxTolgeeModule } from '@tolgee/ngx';
import { AuClassificationBadgeComponent } from '../au-classification-badge/au-classification-badge.component';
import { AuConfigurableFilterComponent } from '../au-configurable-filter/filter-component/au-configurable-filter-component';
import { AuLinkedObjectListComponent } from '../au-linked-object-list/au-linked-object-list.component';
import { CmmsAutocompleteContactComponent } from '@app/pages/cmms/components/shared-form-group-controls/cmms-autocomplete-contact/cmms-autocomplete-contact.component';

@NgModule({
	imports: [
		CommonModule,
		MatProgressSpinnerModule,
		AuConfigurableFilterComponent,
		MatTableModule,
		AuExpandableTagsModule,
		MatIconModule,
		MatMenuModule,
		MatRippleModule,
		AuBodyTextModule,
		AuBodyHeadingModule,
		AuLinkedObjectListComponent,
		AuPipesModule,
		AuBodyTextGreyModule,
		AuStatusLabelModule,
		AuAvatarWithNameModule,
		MatCheckboxModule,
		AuCmmsStatusLabelModule,
		AuLinkedObjectBtnModule,
		AuFileNameModule,
		AuKeyValueComponent,
		AuClassificationBadgeComponent,
		AuDocumentTypeComponent,
		NgxMaskPipe,
		AuNsColumnComponent,
		AuCmmsLabelColumnComponent,
		AuPriorityLevelComponent,
		AssetConditionGradeComponent,
		AuClassificationSuggestionBadgeComponent,
		NgxTolgeeModule,
		CmmsAutocompleteContactComponent,
		AuTableLayoutComponent,
		AuTableComponent,
		NestPipe,
		AuTableCmmsColumnComponent,
		InitialPipe,
		NestedPropPipe,
		ClassificationTypesMenuComponent,
	],
	exports: [AuTableLayoutComponent],
})
export class AuTableLayoutModule {}
